import { useState } from "react";
import { useContextLandingPages } from "src/Contexts/LandingPageContext/LandingPagesContext";
import { api } from "src/shared/setup/API/api";

export const useGetUserPublic = () => {
  const { setSellerData } = useContextLandingPages();

  const [loading, setLoading] = useState(false);

  const handleGetUserPublic = async (idTenant: string) => {
    setLoading(true);

    return api
      .get(`/public/landing-page/get-user-public/${idTenant}`)
      .then((res) => {
        setSellerData(res.data.data);
      })
      .finally(() => setLoading(false));
  };

  return { handleGetUserPublic, loading };
};
